import { Vue, Component } from 'vue-property-decorator';
import SearchInput from '@/components/search-input/search-input.vue';

@Component({
	components: {
		'search-input': SearchInput
	}
})
export default class NavigationSearch extends Vue {
	handleInputChange(value: string): void {
		this.$store.dispatch('navigation/setNavigationSearchFilter', value);
	}
}
